import { toast } from "react-toastify";

import { KEY_debug, KEY_homeImage, KEY_patient, KEY_patient_name } from "../constants";
import { ImageSrcSet, ScreenSizeSpec } from "../types/interfaces";
import { clearStorage, removeFromStorage } from "./storageServies";

const resetSettings = () => {
  // setPreferredLanguage(config.languageConfig.defaultLanguageName);
};

export const cleanupSession = () => {
  console.log('Performing clean-up actions ...');
  clearStorage('SessionStorage');
  resetSettings();
};

export const clearPatientSession = () => {
  removeFromStorage(KEY_homeImage);
  removeFromStorage(KEY_debug);
  removeFromStorage(KEY_patient);
  removeFromStorage(KEY_patient_name);
};



export const toastError = (errorMessage: string, timeout?: number) => {
  toast.error(errorMessage, {
    toastId: 2,
    theme: 'colored',
    autoClose: timeout || false,
    hideProgressBar: true,
  });
};

export const toastResponse = async (successMessage: string) => {
  toast.success(successMessage, {
    toastId: 1,
    theme: 'colored',
    autoClose: 1500,
    hideProgressBar: true,
  });
};

/*
$bs-sm-min: 576px;
$bs-md-min: 768px;
$bs-lg-min: 992px;
$bs-xl-min: 1200px;
*/


export const getImageSrcset = (
  {
    imageFileNameTemplate,
    uniSize,
    sameSize,
    path,
    fileName,
    ext,
    ScreenSizes
  }:
    {
      imageFileNameTemplate?: string;
      path?: string;
      fileName?: string;
      ext?: string
      uniSize?: number;
      sameSize?: boolean;
      ScreenSizes: ScreenSizeSpec[]
    }
): ImageSrcSet => {

  if (imageFileNameTemplate && !fileName && !ext) {
    const seg = imageFileNameTemplate.split('.');
    if (seg.length > 1) {
      fileName = seg.slice(0, seg.length - 1).join('.');
      ext = seg[seg.length - 1];
    }
  }

  if (fileName) {
    fileName = `${fileName}-`;
  }
  else {
    fileName = '';
  }

  if (!ext) {
    ext = '';
  }

  if (fileName.includes('/')) {
    path = '';
  }

  if (path) {
    path = path.endsWith('/') ? path : `${path}/`;
  }
  else {
    path = '';
  }

  const generateSrcSet = (size: ScreenSizeSpec) => {
    return `${path}${fileName}${size.label}.${ext} ${size.width}w`;
  };

  const srcsetStr = ScreenSizes.map(size => generateSrcSet(size)).join(', ');
  let sizesStr = undefined;
  if (!uniSize && !sameSize) {
    const sizesArray: string[] = ScreenSizes.length == 1 ? [`${ScreenSizes[0]}px`] : ScreenSizes.slice(0, ScreenSizes.length - 1).map(size => `(max-width: ${size.width}px) ${size.width}px`);
    if (ScreenSizes.length > 1) { sizesArray.push(`${ScreenSizes.slice(ScreenSizes.length - 1)[0].width}px`); }
    sizesStr = sizesArray.join(', ');
  }
  else if (sameSize && uniSize) {
    sizesStr = `(max-width: ${uniSize}px) 100vw, ${uniSize}px`;

  }
  else {
    sizesStr = undefined;
  }

  const result = {
    srcSet: srcsetStr,
    sizes: sizesStr,
    src: generateSrcSet(ScreenSizes[0])
  };

  return result;
};